export default "__VITE_ASSET__DNo0Q3rm__"